import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MemberSelectorDialogComponent } from './member-selector-dialog.component';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MemberSelectorModule } from '../member-selector/member-selector.module';


@NgModule({
  declarations: [
    MemberSelectorDialogComponent
  ],
    imports: [
        CommonModule,
        MatDialogModule,
        MemberSelectorModule,
    ],
})
export class MemberSelectorDialogModule { }
